import { FC, useState } from "react"
import { ContactForm } from "./ContactForm"
import { ModalWindow } from "./ModalWindow"
import { DateAndTimeStore } from '../Stores/DateAndTimeSlotStoreClass';
import { observer } from "mobx-react-lite";
import { AvailableTimeSlot } from "../Components/Api/ApiClient";


// export type TimeSlot = {
//     from: string,
//     to: string
// }
// type AvailableTimeSlot = {
//     hourfrom: string,
//     minuteFrom: string,
//     hourTo: string,
//     minuteTo: string
// }

type Props = {
    slots: AvailableTimeSlot[]
}

export const ShowTimeSlots: FC<Props> = observer(
    ({ slots }) => {
        const selectedTime = DateAndTimeStore.timeSlot;
        //const [selectedTime, setSelectedTime] = useState<AvailableTimeSlot | null>(null);

        const handleSetSelectedTime = (value: AvailableTimeSlot) => {
            DateAndTimeStore.setTimeSlot(value);
        }

        const handleCloseModal = () => {
            DateAndTimeStore.setDate(null);
            DateAndTimeStore.setTimeSlot(null);
            DateAndTimeStore.setAvailableTimeSlots([]);
        }

        return (
            <>
                <div className="btnFlex">
                    {slots.slice().sort(timeSlotSorter).map((s) => {
                        return <button key={`${s.hourFrom} ${s.minuteFrom} ${s.hourTo} ${s.minuteTo}`} type="button" className="btn" onClick={() => handleSetSelectedTime(s)}>{s.hourFrom}:{getMinutesForList(s.minuteFrom)} - {s.hourTo}:{getMinutesForList(s.minuteTo)}</button>
                    })}

                </div>
                {selectedTime !== null ? <ModalWindow onClose={handleCloseModal} /> : null}
            </>

        )
    }
)

function timeSlotSorter(a: AvailableTimeSlot, b: AvailableTimeSlot): number {
    const aWithLeadingZero = `${addLeadingZero(a.hourFrom)}${addLeadingZero(a.minuteFrom)}`
    const bWithLeadingZero = `${addLeadingZero(b.hourTo)}${addLeadingZero(b.minuteTo)}`;

    if (aWithLeadingZero < bWithLeadingZero) {
        return -1;
    }
    if (aWithLeadingZero > bWithLeadingZero) {
        return 1;
    }
    return 0;
}

function addLeadingZero(text: string): string {
    const value = text.toString();
    if (value.length < 2) {
        return "0" + value;
    }
    return value;
}


function getMinutesForList(minute: string): string {
    return `${addZero(minute)}`;

}
function addZero(number: string): string {
    const value = number.toString();
    if (value.length < 2) {
        return value + "0";
    }
    return value;
}